import { Component, ViewEncapsulation, OnInit, Input, Output, EventEmitter, OnChanges, AfterViewInit } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormArray, UntypedFormControl, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService, AlertService } from '@app/_services';
import { ApiResponse } from '@app/_models';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { User } from '@app/_models/user';
import { LazyLoadEvent, SelectItem } from 'primeng/api';
import { TaskService } from '@app/_components/task';
import { take } from 'rxjs/operators';
import { UsernameValidator, PhoneValidator } from '@app/_components/validators';

@Component({
    selector: 'app-user-add',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.css'],
    standalone: false
})
export class UserComponent implements OnInit, OnChanges, AfterViewInit
{

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private taskUserService: UserService,
		private alertService: AlertService,
		private taskService: TaskService,
		private userService: UserService,
		private location: Location,
		private formBuilder: UntypedFormBuilder) {
		// Initialize form groups early so template [formGroup] bindings don't throw
		// _rawValidators before ngOnInit. buildAddForm() / buildEditForm() in ngOnInit
		// replace these with the real validated groups.
		this.userAddForm = this.formBuilder.group({});
		this.userEditForm = this.formBuilder.group({});
	}


	// inputs
	@Input() taskUserRole: number;
	@Input() taskId: number;
	@Input() users = [];
	@Input() expandAddFormOnCreate: Boolean = false;
	@Input() expandAddFormOnEdit: Boolean = false;
	@Input() addHeaderText: any;
	@Input() formAction: String;

	// structure
	subscription: Subscription;
	routerLocation = this.location;
	// data
	userApiResponse: ApiResponse;

	// list
	datasource;
	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];


	// forms
	userAddForm: UntypedFormGroup;
	userEditForm: UntypedFormGroup;
	formLoading = false;
	formReady = false;
	formLabels = [];
	formReadOnly = false;
	userSuggestions: string[];
	userRolesSelected;
	userRoleList;
	userEdit;

	// visual
	addFormExpanded: Boolean = false;

	userStatusOptions: SelectItem[] = [
		{ label: 'Active', value: 'A', },
		{ label: 'Suspended', value: 'S' },
		{ label: 'Canceled', value: 'C' }
	];

	userRoles = [
		{ value: 1, name: 'General', color: '#DCDCDC' },
		{ value: 2, name: 'Action Item', color: '#ffcccc' },
		{ value: 3, name: 'Status Report', color: '#FFFF99' }
	];

	genders = [
		{ value: 'M', name: 'Male' },
		{ value: 'F', name: 'Female' }
	];

	phoneTypes = [
		{ value: '1', name: 'Primary' },
		{ value: '2', name: 'Home' },
		{ value: '3', name: 'Mobile' },
		{ value: '4', name: 'Work' },
		{ value: '5', name: 'Fax' },
		{ value: '6', name: 'Pager' },
		{ value: '7', name: 'Other' },
	];

	emailTypes = [
		{ value: '1', name: 'Primary' },
		{ value: '2', name: 'Home' },
		{ value: '3', name: 'Work' },
		{ value: '4', name: 'Tax' },
		{ value: '5', name: 'Other' },
	];

	addressTypes = [
		{ value: 1, name: 'Business' },
		{ value: 2, name: 'Home' },
		{ value: 3, name: 'Mailing' },
	];

	visibilities = [
		{ value: 1, name: 'Company' },
		{ value: 2, name: 'Team' },
		{ value: 3, name: 'Personal' },
		{ value: 1, name: '' },
		{ value: 4, name: 'Customer/Owner' }
	];

	statuses = [
		{ value: 2, name: 'Proposed' },
		{ value: 0, name: 'Active' },
		{ value: 3, name: 'On Hold' },
		{ value: 1, name: 'Complete' },
		{ value: 4, name: 'Canceled' }
	];

	columns: any[] = [
		{ field: 'userId', header: 'Id', filterMatchMode: 'startsWith' },
		{ field: 'status', header: 'Status', filterMatchMode: 'startsWith' },
		{ field: 'firstName', header: 'First', filterMatchMode: 'startsWith' },
		{ field: 'lastName', header: 'Last', filterMatchMode: 'startsWith' },
		{ field: 'email', header: 'Email', filterMatchMode: 'startsWith' },
		{ field: 'lastLogin', header: 'Login', filterMatchMode: 'startsWith' }
	];

	filters: any[] = [
		{ label: 'Created', value: 'createDate' },
		{ label: 'Edited', value: 'lastUpdate' },
		{ label: 'Status', value: 'status' },
		{ label: 'Type', value: 'userType' },
		{ label: 'Visibility', value: 'visibility' },

	];

	// list of countries and states https://gist.github.com/ebaranov/41bf38fdb1a2cb19a781
	countries: any[] =
		[
			{ name: 'Canada', value: 'CA' },
			{ name: 'United States', value: 'US' },
			{ name: '', value: '' },
			{ name: 'Afghanistan', value: 'AF' },
			{ name: 'Aland Islands', value: 'AX' },
			{ name: 'Albania', value: 'AL' },
			{ name: 'Algeria', value: 'DZ' },
			{ name: 'American Samoa', value: 'AS' },
			{ name: 'AndorrA', value: 'AD' },
			{ name: 'Angola', value: 'AO' },
			{ name: 'Anguilla', value: 'AI' },
			{ name: 'Antarctica', value: 'AQ' },
			{ name: 'Antigua and Barbuda', value: 'AG' },
			{ name: 'Argentina', value: 'AR' },
			{ name: 'Armenia', value: 'AM' },
			{ name: 'Aruba', value: 'AW' },
			{ name: 'Australia', value: 'AU' },
			{ name: 'Austria', value: 'AT' },
			{ name: 'Azerbaijan', value: 'AZ' },
			{ name: 'Bahamas', value: 'BS' },
			{ name: 'Bahrain', value: 'BH' },
			{ name: 'Bangladesh', value: 'BD' },
			{ name: 'Barbados', value: 'BB' },
			{ name: 'Belarus', value: 'BY' },
			{ name: 'Belgium', value: 'BE' },
			{ name: 'Belize', value: 'BZ' },
			{ name: 'Benin', value: 'BJ' },
			{ name: 'Bermuda', value: 'BM' },
			{ name: 'Bhutan', value: 'BT' },
			{ name: 'Bolivia', value: 'BO' },
			{ name: 'Bosnia and Herzegovina', value: 'BA' },
			{ name: 'Botswana', value: 'BW' },
			{ name: 'Bouvet Island', value: 'BV' },
			{ name: 'Brazil', value: 'BR' },
			{ name: 'British Indian Ocean Territory', value: 'IO' },
			{ name: 'Brunei Darussalam', value: 'BN' },
			{ name: 'Bulgaria', value: 'BG' },
			{ name: 'Burkina Faso', value: 'BF' },
			{ name: 'Burundi', value: 'BI' },
			{ name: 'Cambodia', value: 'KH' },
			{ name: 'Cameroon', value: 'CM' },

			{ name: 'Cape Verde', value: 'CV' },
			{ name: 'Cayman Islands', value: 'KY' },
			{ name: 'Central African Republic', value: 'CF' },
			{ name: 'Chad', value: 'TD' },
			{ name: 'Chile', value: 'CL' },
			{ name: 'China', value: 'CN' },
			{ name: 'Christmas Island', value: 'CX' },
			{ name: 'Cocos (Keeling) Islands', value: 'CC' },
			{ name: 'Colombia', value: 'CO' },
			{ name: 'Comoros', value: 'KM' },
			{ name: 'Congo', value: 'CG' },
			{ name: 'Congo, The Democratic Republic of the', value: 'CD' },
			{ name: 'Cook Islands', value: 'CK' },
			{ name: 'Costa Rica', value: 'CR' },
			{ name: 'Cote D\'Ivoire', value: 'CI' },
			{ name: 'Croatia', value: 'HR' },
			{ name: 'Cuba', value: 'CU' },
			{ name: 'Cyprus', value: 'CY' },
			{ name: 'Czech Republic', value: 'CZ' },
			{ name: 'Denmark', value: 'DK' },
			{ name: 'Djibouti', value: 'DJ' },
			{ name: 'Dominica', value: 'DM' },
			{ name: 'Dominican Republic', value: 'DO' },
			{ name: 'Ecuador', value: 'EC' },
			{ name: 'Egypt', value: 'EG' },
			{ name: 'El Salvador', value: 'SV' },
			{ name: 'Equatorial Guinea', value: 'GQ' },
			{ name: 'Eritrea', value: 'ER' },
			{ name: 'Estonia', value: 'EE' },
			{ name: 'Ethiopia', value: 'ET' },
			{ name: 'Falkland Islands (Malvinas)', value: 'FK' },
			{ name: 'Faroe Islands', value: 'FO' },
			{ name: 'Fiji', value: 'FJ' },
			{ name: 'Finland', value: 'FI' },
			{ name: 'France', value: 'FR' },
			{ name: 'French Guiana', value: 'GF' },
			{ name: 'French Polynesia', value: 'PF' },
			{ name: 'French Southern Territories', value: 'TF' },
			{ name: 'Gabon', value: 'GA' },
			{ name: 'Gambia', value: 'GM' },
			{ name: 'Georgia', value: 'GE' },
			{ name: 'Germany', value: 'DE' },
			{ name: 'Ghana', value: 'GH' },
			{ name: 'Gibraltar', value: 'GI' },
			{ name: 'Greece', value: 'GR' },
			{ name: 'Greenland', value: 'GL' },
			{ name: 'Grenada', value: 'GD' },
			{ name: 'Guadeloupe', value: 'GP' },
			{ name: 'Guam', value: 'GU' },
			{ name: 'Guatemala', value: 'GT' },
			{ name: 'Guernsey', value: 'GG' },
			{ name: 'Guinea', value: 'GN' },
			{ name: 'Guinea-Bissau', value: 'GW' },
			{ name: 'Guyana', value: 'GY' },
			{ name: 'Haiti', value: 'HT' },
			{ name: 'Heard Island and Mcdonald Islands', value: 'HM' },
			{ name: 'Holy See (Vatican City State)', value: 'VA' },
			{ name: 'Honduras', value: 'HN' },
			{ name: 'Hong Kong', value: 'HK' },
			{ name: 'Hungary', value: 'HU' },
			{ name: 'Iceland', value: 'IS' },
			{ name: 'India', value: 'IN' },
			{ name: 'Indonesia', value: 'ID' },
			{ name: 'Iran, Islamic Republic Of', value: 'IR' },
			{ name: 'Iraq', value: 'IQ' },
			{ name: 'Ireland', value: 'IE' },
			{ name: 'Isle of Man', value: 'IM' },
			{ name: 'Israel', value: 'IL' },
			{ name: 'Italy', value: 'IT' },
			{ name: 'Jamaica', value: 'JM' },
			{ name: 'Japan', value: 'JP' },
			{ name: 'Jersey', value: 'JE' },
			{ name: 'Jordan', value: 'JO' },
			{ name: 'Kazakhstan', value: 'KZ' },
			{ name: 'Kenya', value: 'KE' },
			{ name: 'Kiribati', value: 'KI' },
			{ name: 'Korea, Democratic People\'S Republic of', value: 'KP' },
			{ name: 'Korea, Republic of', value: 'KR' },
			{ name: 'Kuwait', value: 'KW' },
			{ name: 'Kyrgyzstan', value: 'KG' },
			{ name: 'Lao People\'S Democratic Republic', value: 'LA' },
			{ name: 'Latvia', value: 'LV' },
			{ name: 'Lebanon', value: 'LB' },
			{ name: 'Lesotho', value: 'LS' },
			{ name: 'Liberia', value: 'LR' },
			{ name: 'Libyan Arab Jamahiriya', value: 'LY' },
			{ name: 'Liechtenstein', value: 'LI' },
			{ name: 'Lithuania', value: 'LT' },
			{ name: 'Luxembourg', value: 'LU' },
			{ name: 'Macao', value: 'MO' },
			{ name: 'Macedonia, The Former Yugoslav Republic of', value: 'MK' },
			{ name: 'Madagascar', value: 'MG' },
			{ name: 'Malawi', value: 'MW' },
			{ name: 'Malaysia', value: 'MY' },
			{ name: 'Maldives', value: 'MV' },
			{ name: 'Mali', value: 'ML' },
			{ name: 'Malta', value: 'MT' },
			{ name: 'Marshall Islands', value: 'MH' },
			{ name: 'Martinique', value: 'MQ' },
			{ name: 'Mauritania', value: 'MR' },
			{ name: 'Mauritius', value: 'MU' },
			{ name: 'Mayotte', value: 'YT' },
			{ name: 'Mexico', value: 'MX' },
			{ name: 'Micronesia, Federated States of', value: 'FM' },
			{ name: 'Moldova, Republic of', value: 'MD' },
			{ name: 'Monaco', value: 'MC' },
			{ name: 'Mongolia', value: 'MN' },
			{ name: 'Montserrat', value: 'MS' },
			{ name: 'Morocco', value: 'MA' },
			{ name: 'Mozambique', value: 'MZ' },
			{ name: 'Myanmar', value: 'MM' },
			{ name: 'Namibia', value: 'NA' },
			{ name: 'Nauru', value: 'NR' },
			{ name: 'Nepal', value: 'NP' },
			{ name: 'Netherlands', value: 'NL' },
			{ name: 'Netherlands Antilles', value: 'AN' },
			{ name: 'New Caledonia', value: 'NC' },
			{ name: 'New Zealand', value: 'NZ' },
			{ name: 'Nicaragua', value: 'NI' },
			{ name: 'Niger', value: 'NE' },
			{ name: 'Nigeria', value: 'NG' },
			{ name: 'Niue', value: 'NU' },
			{ name: 'Norfolk Island', value: 'NF' },
			{ name: 'Northern Mariana Islands', value: 'MP' },
			{ name: 'Norway', value: 'NO' },
			{ name: 'Oman', value: 'OM' },
			{ name: 'Pakistan', value: 'PK' },
			{ name: 'Palau', value: 'PW' },
			{ name: 'Palestinian Territory, Occupied', value: 'PS' },
			{ name: 'Panama', value: 'PA' },
			{ name: 'Papua New Guinea', value: 'PG' },
			{ name: 'Paraguay', value: 'PY' },
			{ name: 'Peru', value: 'PE' },
			{ name: 'Philippines', value: 'PH' },
			{ name: 'Pitcairn', value: 'PN' },
			{ name: 'Poland', value: 'PL' },
			{ name: 'Portugal', value: 'PT' },
			{ name: 'Puerto Rico', value: 'PR' },
			{ name: 'Qatar', value: 'QA' },
			{ name: 'Reunion', value: 'RE' },
			{ name: 'Romania', value: 'RO' },
			{ name: 'Russian Federation', value: 'RU' },
			{ name: 'RWANDA', value: 'RW' },
			{ name: 'Saint Helena', value: 'SH' },
			{ name: 'Saint Kitts and Nevis', value: 'KN' },
			{ name: 'Saint Lucia', value: 'LC' },
			{ name: 'Saint Pierre and Miquelon', value: 'PM' },
			{ name: 'Saint Vincent and the Grenadines', value: 'VC' },
			{ name: 'Samoa', value: 'WS' },
			{ name: 'San Marino', value: 'SM' },
			{ name: 'Sao Tome and Principe', value: 'ST' },
			{ name: 'Saudi Arabia', value: 'SA' },
			{ name: 'Senegal', value: 'SN' },
			{ name: 'Serbia and Montenegro', value: 'CS' },
			{ name: 'Seychelles', value: 'SC' },
			{ name: 'Sierra Leone', value: 'SL' },
			{ name: 'Singapore', value: 'SG' },
			{ name: 'Slovakia', value: 'SK' },
			{ name: 'Slovenia', value: 'SI' },
			{ name: 'Solomon Islands', value: 'SB' },
			{ name: 'Somalia', value: 'SO' },
			{ name: 'South Africa', value: 'ZA' },
			{ name: 'South Georgia and the South Sandwich Islands', value: 'GS' },
			{ name: 'Spain', value: 'ES' },
			{ name: 'Sri Lanka', value: 'LK' },
			{ name: 'Sudan', value: 'SD' },
			{ name: 'Suriname', value: 'SR' },
			{ name: 'Svalbard and Jan Mayen', value: 'SJ' },
			{ name: 'Swaziland', value: 'SZ' },
			{ name: 'Sweden', value: 'SE' },
			{ name: 'Switzerland', value: 'CH' },
			{ name: 'Syrian Arab Republic', value: 'SY' },
			{ name: 'Taiwan, Province of China', value: 'TW' },
			{ name: 'Tajikistan', value: 'TJ' },
			{ name: 'Tanzania, United Republic of', value: 'TZ' },
			{ name: 'Thailand', value: 'TH' },
			{ name: 'Timor-Leste', value: 'TL' },
			{ name: 'Togo', value: 'TG' },
			{ name: 'Tokelau', value: 'TK' },
			{ name: 'Tonga', value: 'TO' },
			{ name: 'Trinidad and Tobago', value: 'TT' },
			{ name: 'Tunisia', value: 'TN' },
			{ name: 'Turkey', value: 'TR' },
			{ name: 'Turkmenistan', value: 'TM' },
			{ name: 'Turks and Caicos Islands', value: 'TC' },
			{ name: 'Tuvalu', value: 'TV' },
			{ name: 'Uganda', value: 'UG' },
			{ name: 'Ukraine', value: 'UA' },
			{ name: 'United Arab Emirates', value: 'AE' },
			{ name: 'United Kingdom', value: 'GB' },

			{ name: 'United States Minor Outlying Islands', value: 'UM' },
			{ name: 'Uruguay', value: 'UY' },
			{ name: 'Uzbekistan', value: 'UZ' },
			{ name: 'Vanuatu', value: 'VU' },
			{ name: 'Venezuela', value: 'VE' },
			{ name: 'Viet Nam', value: 'VN' },
			{ name: 'Virgin Islands, British', value: 'VG' },
			{ name: 'Virgin Islands, U.S.', value: 'VI' },
			{ name: 'Wallis and Futuna', value: 'WF' },
			{ name: 'Western Sahara', value: 'EH' },
			{ name: 'Yemen', value: 'YE' },
			{ name: 'Zambia', value: 'ZM' },
			{ name: 'Zimbabwe', value: 'ZW' }
		];

	// validation
	validationMessages = {
		'name': [
			{ type: 'required', message: 'Required' }
		],
		'taskId': [],
		'userId': [],
		'createDate': [],
		'status': [],

		// name
		'firstName': [],
		'middleName': [],
		'lastName': [],
		'suffix': [],
		'companyName': [],
		'notes': [],
		// role
		'title': [],
		'role': [],
		'userRole': [],

		// email
		'email': [],
		'emailType': [],
		'email2': [],
		'email2Type': [],
		'email3': [],
		'email3Type': [],
		'email4': [],
		'email4Type': [],

		// phones
		'phone': [],
		'phoneType': [],
		'phone2': [],
		'phone2Type': [],
		'phone3': [],
		'phone3Type': [],
		'phone4': [],
		'phone4Type': [],
		'phone5': [],
		'phone5Type': [],
		'phone6': [],
		'phone6Type': [],
		'phone7': [],
		'phone7Type': [],
		'phone8': [],
		'phone8Type': [],
		// address
		'adrType': [],
		'adrStreet': [],
		'adrStreet2': [],
		'adrCity': [],
		'adrState': [],
		'adrPostalCode': [],
		'adrCountry': [],

		// address
		'adr2Type': [],
		'adr2AddressType': [],
		'adr2Street': [],
		'adr2Street2': [],
		'adr2City': [],
		'adr2State': [],
		'adr2PostalCode': [],
		'adr2Country': [],

		// id
		'iMID': [],
		'iMService': [],

		// tax
		'taxID': [],
		'sSN': [],

		// bio
		'website': [],
		'pictureURL': [],
		'anniversary': [], // use for picture
		'birthday': [],
		'birthdate': [],
		'children': [],
		'gender': [],
		'language': [],
		'companyLicense': [],

		// credentials
		'username': [
			{ type: 'required', message: 'Username is required' },
			{ type: 'minlength', message: 'Username must be at least 5 characters long' },
			{ type: 'maxlength', message: 'Username cannot be more than 30 characters long' },
			{ type: 'pattern', message: 'Your username may contain only numbers and letters' }
		],

		'failedloginCount': [
			{ type: 'pattern', message: 'Numbers only' },
			{ type: 'maxlength', message: '1 characters maximum' }
		],

		'hintQuestion': [
			{ type: 'maxlength', message: '80 characters maximum' }
		],

		'hintAnswer': [
			{ type: 'maxlength', message: '80 characters maximum' }
		],


	};



	ngOnInit()
	{
		try
		{
			// userRoleList - passed to userRole component
			this.userRoleList = this.activatedRoute.snapshot.data.userRoleListResApi.data.userRoles;

			this.buildAddForm();
			this.buildEditForm();
			this.formReady = true;

			// user-role feature
			this.onUserRoleSelectionChanges();

			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error)
		{
			console.log('Error: ' + error);
		}
	}

	ngAfterViewInit()
	{
		this.initializeViewPreferences();
	}

	formAdd()
	{
		console.log('trying to add: ');
		try
		{
			// stop here if form is invalid
			if (this.userAddForm.invalid)
			{
				return;
			}

			if (this.userAddForm.value.email.includes(","))
			{
				this.alertService.error("Only one email address is allowed");
				return;
			}

			this.formLoading = true;

			// use the .pipe(take(1)) to prevent double firing...
			this.userService.add(this.userAddForm.value).pipe(take(1))
				.subscribe(
					res =>
					{
						console.log('User-Add SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
						this.users.unshift(res.data.user);
						this.buildAddForm();
					},
					err =>
					{
						console.log('User-Add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}

	formUpdate()
	{
		try
		{
			// stop here if form is invalid
			console.log('Form Submitted: ' + JSON.stringify(this.userEditForm.value));
			if (this.userEditForm.invalid)
			{
				const controls = this.userEditForm.controls;
				for (const name in controls)
				{
					if (controls[name].invalid)
					{
						console.log('Form Invalid - Control: ' + name);
					}
				}
				return;
			}

			this.formLoading = true;

			// scrub roles
			this.processUserRoleSubmission(this.userEditForm);

			this.userService.update(this.userEditForm.value)
				.subscribe(
					res =>
					{
						console.log('User-Update SUCCESS: ' + JSON.stringify(res));
						this.users.map((user, i) =>
						{
							if (user.userId === res.data.user.userId)
							{
								this.users[i] = res.data.user;
							}
						});
						this.alertService.success(res, true);
					},
					err =>
					{
						console.log('User-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error)
		{
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	loadLazy(event: LazyLoadEvent)
	{
		try
		{
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			const pageNumber = Math.round(event.first / event.rows);
			this.userService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					apiResponse =>
					{
						// console.log('users are: ' + JSON.stringify(apiResponse));
						this.datasource = apiResponse.data.users;
						this.recordTotal = apiResponse.page.recordTotal;
						this.users = apiResponse.data.users;
					},
					apiResponse =>
					{
						console.log('USER LIST!: ' + JSON.stringify(apiResponse));
						this.alertService.error(apiResponse);
					},
					() =>
					{ this.loading = false; }
				);

			if (this.datasource)
			{
				this.users = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error)
		{
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	sortList(event)
	{
		console.log('formTest', event);
		this.multiSortMeta = [];
		this.multiSortMeta.push({ field: event.value.value, order: 0 });
		this.lazyLoadEvent.multiSortMeta = this.multiSortMeta;
		this.loadLazy(this.lazyLoadEvent);
	}

	updateToUserList(event)
	{
		console.log('updateUserList', event);
		this.users.map((user, i) =>
		{
			if (user.userId === event.userId)
			{
				this.users[i] = event;
			}
		});
	}


	ngOnChanges()
	{
		// This is called when the parent updates. When the parent first initializes, it is in add state, and we have no taskId.  This sets the taskId when add is successful.
		if (this.userAddForm !== undefined)
		{
			this.userAddForm.patchValue({ taskId: this.taskId });
		}
	}


	buildAddForm()
	{

		this.userAddForm = this.formBuilder.group({
			userId: [],
			createDate: [],
			status: [],

			// name
			firstName: [],
			middleName: [],
			lastName: [],
			suffix: [],
			companyName: [],

			// role
			title: [],
			role: [],
			userRole: [],

			// email
			email: [],
			emailType: [],
			email2: [],
			email2Type: [],
			email3: [],
			email3Type: [],
			email4: [],
			email4Type: [],

			// phones
			phone: [],
			phoneType: [],
			phone2: [],
			phone2Type: [],
			phone3: [],
			phone3Type: [],
			phone4: [],
			phone4Type: [],
			phone5: [],
			phone5Type: [],
			phone6: [],
			phone6Type: [],
			phone7: [],
			phone7Type: [],
			phone8: [],
			phone8Type: [],
			// address
			adrType: [],
			adrStreet: [],
			adrStreet2: [],
			adrCity: [],
			adrState: [],
			adrPostalCode: [],
			adrCountry: [],

			// address
			adr2Type: [],
			adr2AddressType: [],
			adr2Street: [],
			adr2Street2: [],
			adr2City: [],
			adr2State: [],
			adr2PostalCode: [],
			adr2Country: [],

			// id
			iMID: [],
			iMService: [],

			// tax
			taxID: [],
			sSN: [],

			// bio
			website: [],
			pictureURL: [],
			anniversary: [], // use for picture
			birthday: [],
			birthdate: [],
			children: [],
			gender: [],
			language: [],
			companyLicense: [],
			notes: []
		});
	}

	buildEditForm()
	{

		this.userEditForm = this.formBuilder.group({

			demoArray: this.formBuilder.array([]),
			userId: [],
			createDate: [],
			status: [],

			// name
			firstName: [],
			middleName: [],
			lastName: [],
			suffix: [],
			companyName: [],

			// role
			title: [],
			role: [],
			userRole: [],

			// email
			email: [],
			emailType: [],
			email2: [],
			email2Type: [],
			email3: [],
			email3Type: [],
			email4: [],
			email4Type: [],

			// phones
			phone: [],
			phoneType: [],
			phone2: [],
			phone2Type: [],
			phone3: [],
			phone3Type: [],
			phone4: [],
			phone4Type: [],
			phone5: [],
			phone5Type: [],
			phone6: [],
			phone6Type: [],
			phone7: [],
			phone7Type: [],
			phone8: [],
			phone8Type: [],

			// address
			adrType: [],
			adrStreet: [],
			adrStreet2: [],
			adrCity: [],
			adrState: [],
			adrPostalCode: [],
			adrCountry: [],

			// address
			adr2Type: [],
			adr2AddressType: [],
			adr2Street: [],
			adr2Street2: [],
			adr2City: [],
			adr2State: [],
			adr2PostalCode: [],
			adr2Country: [],

			// id
			iMID: [],
			iMService: [],

			// tax
			taxID: [],
			sSN: [],

			// bio
			website: [],
			pictureURL: [],
			anniversary: [], // use for picture
			birthday: [],
			birthdate: [],
			children: [],
			gender: [],
			language: [],
			companyLicense: [],
			notes: [],

			// credentials
			username: ['', Validators.compose([
				Validators.maxLength(30),
				Validators.minLength(5),
				/* numbers, letters, @, _, . only */
				Validators.pattern('^[a-zA-Z0-9@_.-]*$')
			])],

			failedloginCount: ['', Validators.compose([
				Validators.maxLength(2),
				Validators.pattern('^[0-9]*$')
			])],

			hintQuestion: ['', Validators.maxLength(80)],
			hintAnswer: ['', Validators.maxLength(80)],
			userRoles: new UntypedFormArray(this.getUserRoleFormControls()),
			selectAll: [this.getUserRoleSelectAllFormControl()]
		});
	}

	patchUser(user)
	{
		console.log('sweet: ' + JSON.stringify(user));
		this.userEdit = user;
		this.userRolesSelected = user.userRoles || [];
		this.userEditForm.patchValue(user);

		// patchValue sets the userRoles FormArray by index with role objects (truthy),
		// which incorrectly marks wrong checkboxes. Reset each control to a proper boolean.
		const rolesArray = this.userEditForm.get('userRoles') as UntypedFormArray;
		rolesArray.controls.forEach((ctrl, i) =>
		{
			ctrl.setValue(this.isUserRoleSelected(this.userRoleList[i].userRoleId), { emitEvent: false });
		});
	}

	initializeViewPreferences()
	{
		if (this.formAction = 'add')
		{
			console.log('ADD 1 ' + this.formAction + ' ' + this.expandAddFormOnCreate + ' ' + this.addFormExpanded);
			if (this.expandAddFormOnCreate)
			{
				this.addFormExpanded = true;
				console.log('ADD 2 ' + this.formAction + ' ' + this.expandAddFormOnCreate + ' ' + this.addFormExpanded);
			}
			else
			{
				console.log('ADD 3 ' + this.formAction + ' ' + this.expandAddFormOnCreate + ' ' + this.addFormExpanded);
				this.addFormExpanded = false;
			}
		}

		if (this.formAction = 'edit')
		{
			if (this.expandAddFormOnEdit)
			{
				this.addFormExpanded = true;
			}
			else
			{
				this.addFormExpanded = false;
			}
		}
	}


	onPasswordReset(user)
	{
		// stop here if form is invalid
		if (!user)
		{
			return;
		}

		this.userService.resetPasswordRequest(user)
			.pipe(first())
			.subscribe(
				data =>
				{
					console.log('password-reset-request.component SUCCESS: ' + JSON.stringify(data));
					this.alertService.success(data, true);
				},
				error =>
				{
					console.log('error in password-reset-request.component: ' + JSON.stringify(error));
					this.alertService.error(error);
					this.formLoading = false;
				});
	}


	/**
			 *
			 *  BEGIN: USER ROLE PROCESSING
			 *  Dynamic checkboxes inspired from http://marcusresell.com/2018/07/18/dynamic-checkbox-angular/
			 */

	getUserRoleFormControls()
	{
		return this.userRoleList.map(control => new UntypedFormControl(this.isUserRoleSelected(control.userRoleId)));
	}

	getUserRoleSelectAllFormControl()
	{
		return new UntypedFormControl(false);
	}

	processUserRoleSubmission(form: UntypedFormGroup)
	{
		/** UserRoles: Process checked items */
		console.log('processUserRoleSubmission: ' + JSON.stringify(form.value));
		let userRoleSelection = form.value.userRoles.map((checked, index) => checked ? this.userRoleList[index].userRoleId : null).filter(value => value !== null);
		form.value.userRoles = userRoleSelection.map((userRoleId) =>
		{
			return { 'userRoleId': userRoleId };
		});

		/** remove the 'selectAll' checkbox used to check or uncheck all values from submitting to server */
		delete this.userEditForm.value['selectAll'];

		/** END: UserRoles: Process checked items */
	}


	onUserRoleSelectionChanges(): void
	{
		// Subscribe to changes on the selectAll checkbox
		this.userEditForm.get('selectAll').valueChanges.subscribe(bool =>
		{
			this.userEditForm.get('userRoles').patchValue(Array(this.userRoleList.length).fill(bool), { emitEvent: false });
		});

		// Subscribe to changes on the music preference checkboxes
		this.userEditForm.get('userRoles').valueChanges.subscribe(val =>
		{
			const allSelected = val.every(bool => bool);
			if (this.userEditForm.get('selectAll').value !== allSelected)
			{
				this.userEditForm.get('selectAll').patchValue(allSelected, { emitEvent: false });
			}
		});
	}


	isUserRoleSelected(id): boolean
	{
		if (this.userEdit)
		{
			console.log('userRoles assigned: ' + JSON.stringify(this.userRolesSelected));
			console.log('is this assigned? (' + id + ')');

			for (let i = 0; i < this.userRolesSelected.length; i++)
			{
				if (id === this.userRolesSelected[i].userRoleId)
				{
					console.log('answer is true!: (' + this.userRolesSelected[i].name + ')');
					return true;
				}
			}
			return false; // didn't find it
		}
		else { return false; } // no user present
	}

	/**
		 *
		 *  END: USER ROLE PROCESSING
		 *
		 */

}
